import React from 'react';
import { BookOpen, Target, ListChecks, Layers, Search } from 'lucide-react';
import { SectionCard } from './shared';
import { methodologyData } from '../../data/methodologyData';

const Bullets = ({ items }) => (
  <ul className="space-y-1.5">
    {(items || []).map((it, i) => (
      <li key={i} className="flex items-start gap-2 font-medium text-sm text-ink/80">
        <span className="mt-1.5 w-1.5 h-1.5 bg-ink flex-shrink-0" />
        <span>{it}</span>
      </li>
    ))}
  </ul>
);

const MethodologyTab = () => {
  const m = methodologyData || {};
  const overview = m.overview || {};
  const fourPhase = m.fourPhaseProcess || {};
  const evidence = m.evidenceGatheringApproach || {};

  return (
    <div>
      <div className="bg-ink text-white border border-ink/10 rounded-lg shadow-saas mb-6 p-6">
        <h2 className="font-bold tracking-tight text-2xl mb-1">{m.title || 'Review Methodology'}</h2>
        {m.subtitle && <p className="font-medium text-white/80">{m.subtitle}</p>}
      </div>

      {overview.definition && (
        <SectionCard title="What This Review Is" icon={BookOpen}>
          <p className="font-medium text-ink/80 leading-relaxed">{overview.definition}</p>
          {overview.scope && (
            <p className="font-medium text-ink/70 leading-relaxed mt-3">{overview.scope}</p>
          )}
        </SectionCard>
      )}

      {overview.objectives && (
        <SectionCard title="Objectives" icon={Target}>
          <Bullets items={overview.objectives} />
        </SectionCard>
      )}

      {overview.expectedOutcomes && (
        <SectionCard title="What You Get" icon={ListChecks}>
          <Bullets items={overview.expectedOutcomes} />
        </SectionCard>
      )}

      {fourPhase.phases && (
        <SectionCard title="The Review Approach" icon={Layers} subtitle="How the unified review is structured">
          {fourPhase.description && (
            <p className="font-medium text-ink/70 mb-4">{fourPhase.description}</p>
          )}
          <div className="space-y-3">
            {fourPhase.phases.map((p) => (
              <div key={p.phase} className="bg-cream border border-ink/10 rounded-lg p-4">
                <div className="flex flex-wrap items-center gap-2 mb-1">
                  <span className="bg-lime border border-ink/10 rounded-lg px-2 py-0.5 font-bold text-xs uppercase">
                    Stage {p.phase}
                  </span>
                  <span className="font-bold tracking-tight text-lg">{p.name}</span>
                  {p.duration && (
                    <span className="text-xs font-bold uppercase tracking-wide text-ink/50">
                      {p.duration}
                    </span>
                  )}
                </div>
                {p.description && (
                  <p className="font-medium text-sm text-ink/70">{p.description}</p>
                )}
              </div>
            ))}
          </div>
        </SectionCard>
      )}

      {evidence.principles && (
        <SectionCard title="Evidence Standards" icon={Search}>
          <Bullets items={evidence.principles} />
        </SectionCard>
      )}
    </div>
  );
};

export default MethodologyTab;
